import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";
import { fget } from "../../../API/callsApi";
import useStyles from "../LicensesOverview/LicensesOverview.styles";
import CommonLoader from "../../ReusableComponents/CommonLoader/CommonLoader";
import NoDataFound from "../../ReusableComponents/NoDataFound/NoDataFound";
import AvailableLicenseTableItem from "./AvailableLicenseTableItem";
import CustomPagination from "../../ReusableComponents/CustomPagination/CustomPagination";

const AvailableLicensesTable = ({ licenseSearchValue, getOrgServices }) => {
  const classes = useStyles();
  const params = useParams();
  const [availableLicense, setAvailableLicense] = useState({
    count: 0,
    data: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [licensedUsers, setLicensedUsers] = useState([]);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  const getLicenses = async () => {
    if (params.sid) {
      setIsLoading(true);
      try {
        const res = await fget({
          url: `/admin/license/?org=${params.orgId}&service=${params.sid}&status=available&page=${currentPage}`,
        });
        setAvailableLicense({
          count: res.data.count,
          data: res.data.results,
        });
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    }
  };

  const getActiveLicense = async () => {
    if (params.sid) {
      try {
        const res = await fget({
          url: `/admin/license/?org=${params.orgId}&service=${params.sid}&status=active`,
        });
        const newRes = res.data.results.map((eachLicense) => {
          return eachLicense.user.id;
        });
        setLicensedUsers(newRes);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  useEffect(() => {
    getActiveLicense();
    getLicenses();
  }, [params.sid, refreshCounter, updateOnPageChange]);

  return (
    <>
      <TableContainer style={{ height: "7%", overflow: "hidden" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                className={`${classes.tableRowCellsLicensesAvailable} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                License ID
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.tableRowCellsLicensesAvailable} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                License Type
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.tableRowCellsLicensesAvailable} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                Subscribed on
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.tableRowCellsLicensesAvailable} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                Expiring on
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.tableRowCellsLicensesAvailable} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                <span style={{ marginRight: "40px" }}>Action</span>
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
      <Box
        style={{
          height: availableLicense.count > 50 ? "81%" : "84%",
          overflowY: "auto",
          border: "1px solid black",
          borderRadius: "5px",
        }}
      >
        <TableContainer>
          <Table aria-label="simple table">
            <TableBody style={{ height: "100%" }}>
              {isLoading ? (
                <div className={classes.commonLoader}>
                  <CommonLoader />
                </div>
              ) : availableLicense.data && availableLicense.data.length > 0 ? (
                availableLicense.data
                  ?.filter((search) => {
                    if (licenseSearchValue === undefined) {
                      return search;
                    } else if (licenseSearchValue === "") {
                      return search;
                    } else if (
                      search.license_number
                        .toLowerCase()
                        .includes(licenseSearchValue.toLowerCase())
                    ) {
                      return search;
                    }
                    return null;
                  })
                  .map((eachLicense) => {
                    return (
                      <AvailableLicenseTableItem
                        key={eachLicense.id}
                        eachLicense={eachLicense}
                        licensedUsers={licensedUsers}
                        handleRefreshCounter={handleRefreshCounter}
                        getOrgServices={getOrgServices}
                      />
                    );
                  })
              ) : (
                <NoDataFound />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {availableLicense.count > 50 && (
        <footer style={{ width: "100%", position: "relative" }}>
          <CustomPagination
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            totalItem={availableLicense?.count}
            totalPage={
              availableLicense ? Math.ceil(availableLicense?.count / 50) : 0
            }
            type="Available Licenses"
          />
        </footer>
      )}
    </>
  );
};

export default AvailableLicensesTable;
